module.exports = __webpack_public_path__ + "img/complaints_card2.838fa6f6.png";